<div class="upload-dialog-container">
  <p-toast></p-toast>

  <form [formGroup]="metaDataFormGroup" class="metadata-form">
    <div class="form-grid">
      <div class="field">
        <label for="category">Category <span class="required">*</span></label>
        <input pInputText id="category" formControlName="category" placeholder="e.g. Financial Report" />
      </div>

      <div class="field">
        <label for="year_of_publication">Year of Publication <span class="required">*</span></label>
        <input pInputText id="year_of_publication" formControlName="year_of_publication" placeholder="YYYY" />
      </div>

      <div class="field full-width">
        <label for="description">Description <span class="required">*</span></label>
        <textarea
          pTextarea
          id="description"
          formControlName="description"
          rows="2"
          placeholder="Enter a brief description of the document..."
        ></textarea>
      </div>

      <div class="field full-width">
        <label for="keywords">Keywords <span class="required">*</span></label>
        <p-chips
          id="keywords"
          [style]="{ 'min-width': '18vw' }"
          formControlName="keywords"
          placeholder="Type a keyword and press Enter"
        ></p-chips>
        <small class="helper-text">Press Enter to add one or multiple tags.</small>
      </div>

      <div class="field">
        <label for="link">Document Link <span class="required">*</span></label>
        <input pInputText id="link" formControlName="link" placeholder="https://..." />
      </div>

      <div class="field switch-field full-width">
        <div class="switch-info">
          <label for="latest" class="mb-0">Is Latest Version?</label>
          <small class="helper-text">Mark this if it's the most recent iteration.</small>
        </div>
        <p-toggleswitch id="latest" formControlName="latest"></p-toggleswitch>
      </div>
    </div>

    <div class="dialog-footer">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="closeDialog()">
      </p-button>
      <p-button
        label="Save Metadata"
        icon="pi pi-check"
        severity="success"
        [disabled]="metaDataFormGroup.invalid"
        (onClick)="saveMetadata()"
      >
      </p-button>
    </div>
  </form>
</div>
